import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/LoginPage.css";
import logo from "/assets/logo.svg";


const ForgotPasswordOTP = () => {
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  
  const phoneForgot = JSON.parse(
    sessionStorage.getItem("phoneForgot")
  );

  // ตรวจสอบว่ามีข้อมูลผู้ใช้ใน session storage หรือไม่
  if (!phoneForgot) {
    // หากไม่มีข้อมูลผู้ใช้ ให้ทำการเชื่อมต่อกลับไปที่หน้าอื่นหรือแสดงข้อความข้อผิดพลาด
    
  }



  const navigate = useNavigate(); // Initialize navigate

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/^\d*$/) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 4 && value !== "") {
        // Automatically move to the next input field
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleConfirm = () => {
    navigate("/forgotpassword/setnewpassword"); // ทำการนำทางไปยังหน้าที่คุณต้องการ
  };

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form">
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>

          <div className="forgotPassword">
            <h2>ลืมรหัสผ่าน</h2>
            <p>ยืนยันตัวตนผ่านรหัสผ่าน OTP</p>

            <p>
            หมายเลขโทรศัพท์ xxx xxx {phoneForgot.phone_no}
            </p>

            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  maxLength={1}
                />
              ))}
            </div>

            <h3>
              <span>ไม่ได้รับรหัส OTP</span>{" "}
              <span className="OTP">ส่งใหม่อีกครั้ง</span>
            </h3>
          </div>

          <button
            className="ok-branch"
            type="button"
            onClick={handleConfirm} // เรียกใช้งาน handleConfirm เมื่อคลิกที่ปุ่ม "ตกลง"
          >
            ตกลง
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordOTP;
